import axios from "axios";

const api = axios.create(
    /*
    {baseURL: 'https://mergerfilers.jbaysolutions.com/'}
    */
);


// Add a response interceptor
api.interceptors.response
    .use(function (response) {
        if (window.location.pathname.includes('/admin')) {
            // console.debug('response - interceptor ', response)
            // console.debug('response.request - interceptor ', response.request.responseURL)
            // console.debug('window.location - interceptor ', window.location.href)
            if (response.request.responseURL.includes('/?login=true')) {
                // console.warn('"login=true" found - api interceptor redirecting to login!')
                window.location.assign(response.request.responseURL);
                return response
            }
            if (response.data &&  typeof response.data === 'string' && response.data.startsWith('<!DOCTYPE html>')) {
                // console.warn('redirecting to dashboard')
                window.location.assign('/admin/dashboard');
                return response
            }
        }
        return response;
    }, function (error) {
        // console.error('api response interceptor error ', error);
        if (error.status === 403) {
            window.location.assign('/admin/dashboard');
            return
        }
        throw error
    });


export default api;
